module.exports = __webpack_public_path__ + "static/media/medium_tan_5050.png.5fa5198a.webp";